// @flow

import * as React from "react"
import { FormattedMessage } from "react-intl"
import { AlertStatus, AlertText, AlertIcon } from "./UI"
import SVGLoader from "../../UI/SVGLoader"

import type { CAMMForecast } from "../queries"

import iconHealthWatch from "../Icons/iconHealthWatch.svg"
import iconHPA from "../Icons/iconHPA.svg"

const maxPollutant = (data: CAMMForecast): string => {
  const forecast = data.currentForecast || {}
  return ["pm2_5", "pm10", "o3"]
    .map(metric => [metric, forecast[metric]])
    .sort((a, b) => (a[1] > b[1] ? -1 : 1))[0][0]
}

const iconForForecast = (data: CAMMForecast) => {
  const forecast = data.currentForecast || {}
  return forecast.healthWatch || forecast.highPollutionAdvisory ? (
    <AlertIcon>
      <SVGLoader
        path={forecast.highPollutionAdvisory ? iconHPA : iconHealthWatch}
        height="100%"
        width="100%"
      />
    </AlertIcon>
  ) : (
    <span />
  )
}

const statusForForecast = (data: CAMMForecast) => {
  const forecast = data.currentForecast || {}
  const { highPollutionAdvisory, healthWatch } = forecast
  const status =
    (highPollutionAdvisory && "hpa") || (healthWatch && "hw") || "none"
  return <FormattedMessage id={`kiosk.forecast.status.${status}`} />
}

const AlertBar = ({ data }: { data: CAMMForecast }) => {
  const forecast = data.currentForecast || {}
  return (
    <AlertStatus
      healthWatch={forecast.healthWatch}
      advisory={forecast.highPollutionAdvisory}
    >
      {iconForForecast(data)}
      <AlertText
        centered={!(forecast.healthWatch || forecast.highPollutionAdvisory)}
      >
        {forecast.healthWatch || forecast.highPollutionAdvisory ? (
          maxPollutant(data).replace("_", ".")
        ) : (
          <span />
        )}{" "}
        {statusForForecast(data)}
      </AlertText>
    </AlertStatus>
  )
}

export default AlertBar



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/AlertBar.js